export default {
  regular: 'Averta-Regular, sans-serif',
  bold: 'Averta-ExtraBold, sans-serif',
  light: 'Averta-Regular',
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  xxl: '1.875rem',
  lineHeight: '1.75rem',
};
